import { render, staticRenderFns } from "./MaidAvatar.vue?vue&type=template&id=015a9c8a&scoped=true"
import script from "./MaidAvatar.vue?vue&type=script&lang=js"
export * from "./MaidAvatar.vue?vue&type=script&lang=js"
import style0 from "./MaidAvatar.vue?vue&type=style&index=0&id=015a9c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015a9c8a",
  null
  
)

export default component.exports